<div
  #toastElement
  class="toast align-items-center text-white border-0 mt-4"
  [ngClass]="type"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="d-flex">
    <div class="toast-body">
      {{ message }}
    </div>
    <button
      type="button"
      class="btn-close btn-close-white me-2 m-auto"
      data-bs-dismiss="toast"
      aria-label="Close"
      (click)="hide()"
    ></button>
  </div>
</div>
